import { render } from "./DropShipOrdersContainer.vue?vue&type=template&id=56c1f0b4"
import script from "./DropShipOrdersContainer.vue?vue&type=script&lang=js"
export * from "./DropShipOrdersContainer.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__